import React, { useEffect, useState, useRef, lazy } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const slides = [{
  src: 'https://cdn.magicpatterns.com/uploads/mHVgw9s4dvc7ZNg4SyCCbX/IMG-20260510-WA0027.jpg',
  caption: 'Christ Love at Christmas — Orphanage Outreach'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/f1R2Vny6zLJmaijCMSyGae/IMG-20260510-WA0031.jpg',
  caption: 'Hospital Outreach — Christ Medical Center, Benin City'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/kZrAiEzTqMexLKrw7mfDaQ/IMG-20260510-WA0028.jpg',
  caption: 'Visit to Ajebor Orphanage Home'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/9LCvC9itFaKE48VpCiXSmL/IMG-20260510-WA0026.jpg',
  caption: 'Outreach at Zimran Medical Centre, Benin City'
}];
export function MiniSlider() {
  const [index, setIndex] = useState(0);
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const start = () => {
    stop();
    timerRef.current = setInterval(() => {
      setIndex(i => (i + 1) % slides.length);
    }, 4500);
  };
  const stop = () => {
    if (timerRef.current) clearInterval(timerRef.current);
  };
  useEffect(() => {
    start();
    return stop;
  }, []);
  const go = (dir: number) => {
    setIndex(i => (i + dir + slides.length) % slides.length);
    start();
  };
  return <section className="bg-ivory py-20 md:py-32 overflow-hidden" data-id="element-251">
      <div className="max-w-6xl mx-auto px-6" data-id="element-252">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12" data-id="element-253">
          <div data-id="element-254">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-gold/20 text-midnight rounded-full text-xs font-bold tracking-widest uppercase mb-4" data-id="element-255">
              <span className="w-2 h-2 rounded-full bg-gold" data-id="element-256" />
              On the Field
            </div>
            <h2 className="text-4xl md:text-6xl font-display font-bold text-midnight tracking-tight" data-id="element-257">
              Moments from <br className="hidden md:block" data-id="element-258" />
              <span className="text-gold italic font-serif font-medium" data-id="element-259">
                Outreach
              </span>
            </h2>
          </div>

          <div className="flex gap-3" data-id="element-260">
            <button onClick={() => go(-1)} aria-label="Previous slide" className="w-14 h-14 rounded-full bg-white border-2 border-midnight/10 hover:border-midnight hover:bg-midnight hover:text-ivory flex items-center justify-center transition-all active:scale-95 text-midnight" data-id="element-261">
              <ChevronLeft className="w-6 h-6" data-id="element-262" />
            </button>
            <button onClick={() => go(1)} aria-label="Next slide" className="w-14 h-14 rounded-full bg-white border-2 border-midnight/10 hover:border-midnight hover:bg-midnight hover:text-ivory flex items-center justify-center transition-all active:scale-95 text-midnight" data-id="element-263">
              <ChevronRight className="w-6 h-6" data-id="element-264" />
            </button>
          </div>
        </div>

        <div className="relative w-full max-w-4xl mx-auto" onMouseEnter={stop} onMouseLeave={start} data-id="element-265">
          <div className="relative aspect-[4/3] md:aspect-[16/9] bg-white rounded-[2rem] p-4 shadow-2xl rotate-1" data-id="element-266">
            <div className="relative w-full h-full rounded-2xl overflow-hidden bg-midnight" data-id="element-267">
              <AnimatePresence mode="wait" data-id="element-268">
                <motion.img key={index} src={slides[index].src} alt={slides[index].caption} loading="lazy" decoding="async" initial={{
                opacity: 0,
                scale: 1.05
              }} animate={{
                opacity: 1,
                scale: 1
              }} exit={{
                opacity: 0
              }} transition={{
                duration: 0.5
              }} className="absolute inset-0 w-full h-full object-cover" data-id="element-269" />
              </AnimatePresence>
            </div>

            {/* Polaroid Caption */}
            <div className="absolute -bottom-6 right-8 bg-white px-6 py-4 rounded-2xl shadow-xl -rotate-3 border-2 border-midnight/5 max-w-[80%]" data-id="element-270">
              <AnimatePresence mode="wait" data-id="element-271">
                <motion.p key={index} initial={{
                opacity: 0,
                y: 10
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0,
                y: -10
              }} className="text-midnight font-serif italic text-lg md:text-xl" data-id="element-272">
                  {slides[index].caption}
                </motion.p>
              </AnimatePresence>
            </div>
          </div>

          {/* Pagination */}
          <div className="flex justify-center gap-2 mt-16" data-id="element-273">
            {slides.map((_, i) => <button key={i} onClick={() => {
            setIndex(i);
            start();
          }} aria-label={`Go to slide ${i + 1}`} className={`h-2 rounded-full transition-all duration-300 ${index === i ? 'w-8 bg-gold' : 'w-2 bg-midnight/20'}`} data-id="element-274" />)}
          </div>
        </div>
      </div>
    </section>;
}